import { render, staticRenderFns } from "./ConfirmAskDetail.vue?vue&type=template&id=595630be&scoped=true&"
import script from "./ConfirmAskDetail.vue?vue&type=script&lang=js&"
export * from "./ConfirmAskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595630be",
  null
  
)

export default component.exports